import axios from '@/assets/js/axios.js'
import { ORGANIZATION_SERVICE_API } from './apis'
// 组织列表
export function orgList (params) {
  return axios({
    url: ORGANIZATION_SERVICE_API.LIST,
    method: 'post',
    data: params
  })
}
// 查看组织
export function viewOrg (params) {
  return axios({
    url: ORGANIZATION_SERVICE_API.ORGANIZATION + '/' + params,
    method: 'get'
  })
}
// 删除组织
export function deleteOrg (params) {
  return axios({
    url: ORGANIZATION_SERVICE_API.ORGANIZATION + '/' + params,
    method: 'delete'
  })
}
// 修改组织
export function editOrg (params) {
  return axios({
    url: ORGANIZATION_SERVICE_API.ORGANIZATION,
    method: 'put',
    data: params
  })
}
// 新增组织
export function addOrg (params) {
  return axios({
    url: ORGANIZATION_SERVICE_API.ORGANIZATION,
    method: 'post',
    data: params
  })
}
